import { Position } from '../../../../tables/ultraTable/types/position.types';
import categoryProvider from '../../../../../utilities/categoryProvider';
import { percentageToTwoDecimalPlaces } from '../../../../../utilities/numberFormatters';

export function buildCounterpartyTableData(
  selectedCounterpartyData: any,
): Position[] {
  // counterpartyGeneralMonitorExposure is a single object directly: {exposure_data: {...}, nav: ..., ...}
  const rawData = selectedCounterpartyData;

  if (!rawData || !rawData.exposure_data) {
    return [];
  }

  function doLeverage(input: number) {
    return input / nav;
  }

  const { exposure_data: data, nav } = rawData;
  const finalData: Position[] = [];

  Object.keys(data).forEach((item) => {
    const items = categoryProvider(item.slice(0, 1));
    const assetType = items[1];

    const obj: Position = {
      name: data[item].name,
      asset_class: item.includes('collateral') ? 'COLLATERAL' : assetType,
      asset_type:
        data[item].asset_type.split('')[0].toUpperCase() +
        data[item].asset_type.slice(1),
      isin: data[item].isin || '',
      currency: data[item].currency,
      fx: Number(data[item].fx.toFixed(4)),
      lc_exposure: data[item].lc_exposure,
      bc_exposure: data[item].bc_exposure,
      gross_exposure: data[item].gross_exposure,
      gross_exposure_pct: Number(
        percentageToTwoDecimalPlaces(
          doLeverage(data[item].gross_exposure),
        ).replace('%', ''),
      ),
      unrealised_pl: data[item].unrealised_pl,
      assetInformation: data[item].underlying_assets || [],
    };

    // Transform underlying assets for detail panel
    const adjustedAssetInformationForDetail: any = [];
    if (
      data[item].underlying_assets &&
      Array.isArray(data[item].underlying_assets)
    ) {
      data[item].underlying_assets.forEach((info: any) => {
        const [
          name,
          price,
          delta,
          size,
          risk_factor,
          local_exposure,
          base_exposure,
          gross_exposure,
          commitment,
          country_code,
          country_code_risk_level,
        ] = info;

        let newPrice;
        if (price >= 10) {
          newPrice = Number(price.toFixed(2));
        } else {
          newPrice = Number(price.toFixed(4));
        }

        const detailObj = {
          name,
          price: newPrice,
          delta,
          size,
          riskFactor: risk_factor,
          localExposure: local_exposure,
          baseExposure: base_exposure,
          grossExposure: gross_exposure,
          commitment: commitment,
          countryCode: country_code,
          countryCodeRiskLevel: country_code_risk_level,
        };
        adjustedAssetInformationForDetail.push(detailObj);
      });
    }

    obj['assetInformation'] = adjustedAssetInformationForDetail;

    finalData.push(obj);
  });

  return finalData;
}
